var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, html, LitElement, property } from 'lit-element';
let SimpleGreeting = class SimpleGreeting extends LitElement {
    constructor() {
        super(...arguments);
        this.message = '';
        this.user = '';
        this.date = new Date();
    }
    render() {
        return html `
<style type="text/css">
.chat-entry {
    display: flex;
    margin-bottom: 10px;
}

.chat-entry__main {
    display: flex;
    flex-direction: column;
    padding: 10px;
}

.chat-entry__meta-info {
    color:  #828282;
    font-size: 10px;
    margin-bottom: 5px;

}

.chat-entry__message {
    font-size: 14px;
    font-weight: normal;
}
.chat-entry__user-logo-container {
    display: flex;
    flex-direction: column;
    border-radius: 50%;
    flex: 0 0 10px;
    align-self: flex-start;
    padding-top: 10px;
}

.chat-entry__user-logo {
    background: url('/assets/miu.png') no-repeat;
    background-size: 100%;
    width: 20px;
    height: 20px;
    border-radius: 50%;
}
</style>
            <div class="communication-chat">
                <div class="chat-entry">
                    <div class="chat-entry__user-logo-container">
                        <div class="chat-entry__user-logo">
                        </div>
                    </div>
                    <div class="chat-entry__main">
                        <div class="chat-entry__meta-info">
                            ${this.user} - ${this.date.toUTCString()}
                        </div>
                        <div class="chat-entry__message">
                            ${this.message}
                        </div>
                    </div>
                </div>
            </div>`;
    }
};
__decorate([
    property()
], SimpleGreeting.prototype, "message", void 0);
__decorate([
    property()
], SimpleGreeting.prototype, "user", void 0);
__decorate([
    property()
], SimpleGreeting.prototype, "date", void 0);
__decorate([
    property()
], SimpleGreeting.prototype, "render", null);
SimpleGreeting = __decorate([
    customElement('chat-entry')
], SimpleGreeting);
export { SimpleGreeting };
